<template>
  <div class="main-stations__type2">
    <!--<div class="main-stations__invertors_dmcr type-two-columns"></div>-->
    <div class="main-stations__inverters_dmcr">
      <div class="main-stations__inverters_dmcr_col-left">
        <div class="main-stations__title">Инверторы, %</div>
        <div v-if="station.gridInverters.length === 0" class="main-stations__inverters">
          <div class="main-stations__inverters_col">
            <div class="main-stations__inverters_item">
              <div v-for="inverter in sortByName(station.inverters)" :key="inverter.id"
                class="main-stations__inverters_item_inv">
                <i @click="openInverter(inverter.id)" :class="inverterClass(inverter)">
                  <b>{{ inverter.name }}</b>
                  <b>{{ inverter.percent }}</b>
                </i>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="main-stations__inverters">
          <div v-for="logger in loggers" :key="logger.id" class="main-stations__inverters_col">
            <div class="main-stations__inverters_item">
              <div class="main-stations__inverters_item_inv">
                <!--on, off, warn-->
                <i :class="inverterClass(logger)">
                  <b>{{ logger.name }}</b>
                  <b>{{ logger.percent }}</b>
                </i>
              </div>
              <div class="main-stations__inverters_item_square">
                <div v-for="inverter in sortById(logger.inverters)" :key="inverter.id" :title="inverter.name"
                  class="square-col" @click="openModal(inverter)">
                  <div
                    v-bind:class="((inverter.data !== null) && (inverter.data['Active_power'] > 0)) ? ['square-item', 'green'] : ['square-item', 'grey']">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main-stations__inverters_dmcr_col-right">
        <div class="main-stations__title">DMCR</div>
        <div class="main-stations__dmcr">
          <DMCR :key="dmcr.name" :title="dmcr.name.split('_')[1]" :state="dmcr.value" v-for="dmcr in station.dmcr">
          </DMCR>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import collection from 'lodash/collection'
import DMCR from '@/components/stations/table/DMCR'

export default {
  name: 'Inverters',
  components: { DMCR },
  props: {
    station: {
      type: Object,
      required: true
    }
  },
  methods: {
    sortByName(inverters) {
      return collection.orderBy(inverters, ['name'], ['asc'])
    },
    sortById(inverters) {
      return collection.orderBy(inverters, ['id'], ['asc'])
    },
    inverterClass(inverter) {
      if (inverter.power > 0) {
        return [
          'inv',
          'on'
        ]
      } else if ((inverter.power === -1) || (inverter.power === null)) {
        return [
          'inv',
          'warn'
        ]
      } else {
        return ['inv']
      }
    },
    dmcrClass(val) {
      if (val === null) {
        return 'main-stations__dmcr_item'
      } else if (parseInt(val) === 0) {
        return 'main-stations__dmcr_item orange'
      } else if (parseInt(val) === 1) {
        return 'main-stations__dmcr_item green'
      } else {
        return 'main-stations__dmcr_item'
      }
    },
    openInverter(id) {
      this.$router.push({
        name: 'device-view',
        params: { id: id }
      })
    },
    openModal(inverter) {
      this.$store.commit('stations/SET_INVERTER', inverter)
    }
  },
  computed: {
    loggers() {
      return this.station.inverters.map(logger => {
        let inverters = this.station.gridInverters.filter(inverter => String(inverter.name)
          .startsWith('I_' + logger.name))
        return {
          id: logger.id,
          inverters: inverters,
          percent: logger.percent,
          power: logger.power,
          name: logger.name
        }
      })
    }
  }
}
</script>
